import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export type EntityType = "CRSReportingFI" | "PillarTwoUPE" | "CbCRMNEGroup" | "DataCustodian";

export type RevocationReasonType =
  | "AgentMisconduct"
  | "ClientPreference"
  | "FirmChange"
  | "AuthorisationReplaced"
  | "Other";

export interface LinkedEntity {
  linkId: string;
  entityId: string;
  entityName: string;
  entityType: EntityType;
  linkStatus: "Active" | "Pending" | "Revoked" | "Expired";
  permissionsLevel?: string;
  permissions: string[];
  canDraft?: boolean;
  canSubmit?: boolean;
  canAmend?: boolean;
  linkedDate: string;
  linkedBy: "AgentRequest" | "EntityInvite";
  revokedAt?: string;
  revokedBy?: string;
  revocationReason?: RevocationReasonType;
  revocationDetails?: string;
  expiresAt?: string;
  gracePeriodEndsAt?: string;
  renewedAt?: string;
  isInGracePeriod?: boolean;
  daysUntilExpiry?: number | null;
}

export interface SelectedEntity {
  entityId: string;
  entityName: string;
  entityType: EntityType;
}

// Persisted — survives page refresh, cleared on logout
export const selectedEntityAtom = atomWithStorage<SelectedEntity | null>(
  "agentPortalSelectedEntity",
  null,
  undefined,
  { getOnInit: true },
);
selectedEntityAtom.debugLabel = "selectedEntityAtom";

export const entityListAtom = atom<LinkedEntity[]>([]);
entityListAtom.debugLabel = "entityListAtom";

export const activeEntitiesAtom = atom<LinkedEntity[]>((get) => {
  return get(entityListAtom).filter((e) => e.linkStatus === "Active");
});
activeEntitiesAtom.debugLabel = "activeEntitiesAtom";

export const clearEntityContextAtom = atom(null, (_get, set) => {
  set(selectedEntityAtom, null);
  set(entityListAtom, []);
});
clearEntityContextAtom.debugLabel = "clearEntityContextAtom";
